<template>
  <div class="demo-card-list">
    <div
      class="demo-commodit-card"
      v-for="(item, index) in dataList"
      :key="index"
    >
      <div class="demo-card-imgbox flex-center" @click="toDetail(item.id)">
        <el-image class="img_box" :src="item.picFile">
          <div slot="error" class="image-slot">
            <img class="img_box" src="../assets/images/default_img.jpg" />
          </div>
        </el-image>
      </div>
      <div class="demo-card-body-box">
        <el-tooltip
          :content="item.subjectName"
          placement="top"
          v-ak-tooltip-auto-show
        >
          <div class="title ellipsis-aRow" @click="toDetail(item.id)">
            {{ item.subjectName }}
          </div>
        </el-tooltip>

        <div class="demo-card-info">
          <div class="resource ellipsis-aRow">
            共{{ item.resourcesNun }}个商品
          </div>
          <div class="price" v-if="item.priceRadio != 3">
            <span class="sellprice ellipsis-aRow">{{
              item.sellingPrice | tofixed2("￥")
            }}</span>
            <span
              v-if="item.price > 0"
              class="ellipsis-aRow"
              :class="item.price == 0 ? 'yprice2' : 'yprice'"
              >{{ item.price | tofixed2("￥") }}</span
            >
          </div>
          <div v-else class="price price_no">暂无售价</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    dataList: Array,
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/special/specialDetail",
        query: { subjectId: id },
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.demo-card-list {
  margin: 15px 0 30px;
  display: grid;
  grid-row-gap: 30px;
  column-gap: 20px;
  grid-template-columns: repeat(4, 320px);
  .demo-commodit-card {
    width: 320px;
    height: 324px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .demo-card-imgbox {
      width: 320px;
      height: 240px;
      cursor: pointer;
      .img_box {
        background-position: center center;
        background-size: cover;
      }
    }
    .demo-card-body-box {
      padding: 10px 10px 15px 14px;
      .title {
        margin-bottom: 10px;
        font-size: 16px;
        height: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        max-width: 280px;
        cursor: pointer;
        display: inline-block;
      }
      .title:hover {
        color: #1690ff;
        text-decoration: underline;
      }
      .demo-card-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .resource {
          max-width: 155px;
          box-sizing: border-box;
          padding: 0 5px;
          min-width: 100px;
          height: 28px;
          background: #ffffff;
          border: 1px solid #0081ce;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          text-align: center;
          line-height: 28px;
        }
        .price {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ff5353;
          display: flex;
          align-items: center;
          .sellprice {
            display: inline-block;
            max-width: 122px;
          }
          .yprice {
            margin-left: 4px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            text-decoration: line-through;
            color: #999999;
            max-width: 74px;
            display: inline-block;
          }
          .yprice2 {
            margin-left: 4px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            // text-decoration: none;
            text-decoration: line-through;
            color: #999999;
            max-width: 74px;
            display: inline-block;
          }
        }
        .price_no {
          font-size: 16px;
          color: #999999;
        }
      }
    }
  }
}
</style>
